import { GetKeys } from '@/types';

export type DayOptions =
  | 'weekdays'
  | 'weekends'
  | 'everyday'
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export type Schedule = {
  status?: boolean;
  timezone?: string;
  dates?: Array<{
    days: DayOptions;
    startTime: string;
    endTime: string;
  }>;
};

export const GPTModels = {
  GPT4o: 'gpt-4o',
  GPT4oMINI: 'gpt-4o-mini',
  /*   GPT45PREVIEW: 'gpt-4.5-preview', */
  GPT3Mini: 'o3-mini',
  GPT01: 'o1',
  CLAUDE3SONNET: 'anthropic.claude-3-sonnet-20240229-v1:0',
  CLAUDE35SONNET: 'anthropic.claude-3-5-sonnet-20240620-v1:0',
  CLAUDE37SONNET: 'us.anthropic.claude-3-7-sonnet-20250219-v1:0',
  LLAMA3_1_70B: 'meta-llama/Meta-Llama-3.1-70B-Instruct',
  LLAMA3_1_405B: 'meta-llama/Meta-Llama-3.1-405B-Instruct',
  LLAMA4_SCOUT_17B: 'meta-llama/Llama-4-Scout-17B-16E-Instruct',
  LLAMA4_MAVERICK_17B: 'meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8',
  DEEPSEEK_R1: 'deepseek-ai/DeepSeek-R1',
  DEEPSEEK_V3: 'deepseek-ai/DeepSeek-V3',
  GEMINI_2_5_PRO: 'gemini-2.5-pro-preview-03-25',
  GROK3: 'grok-3-latest',
} as const;

export type GPTModel = (typeof GPTModels)[keyof typeof GPTModels];

export type GPTModels = {
  value: GPTModel;
  label: string;
};

export const MaxValueOptions = {
  SHORT: 250,
  MEDIUM: 500,
  LONG: 750,
} as const;

export type MaxValueOption =
  (typeof MaxValueOptions)[keyof typeof MaxValueOptions];

export type MaxValueOptions = {
  value: MaxValueOption;
  label: string;
};

export type CollectUserData = {
  status: boolean;
  after: number;
  email: {
    status: boolean;
    required: boolean;
  };
  phone: {
    status: boolean;
    required: boolean;
  };
  fullName: {
    status: boolean;
    required: boolean;
  };
};

export type SettingData = {
  basePrompt: string;
  gptModel: GPTModel;
  maxTokens: number;
  maxInputLength: number;
  temperature: number;
  aiName: string;
  company: string | null | undefined;
  isRestricted: boolean;
  isImageSharingEnabled: boolean;
  isLearnMoreEnabled: boolean;
  followUpQuestionEnabled: boolean;
  customDoNotKnowMessage: string | null | undefined;
  collectUserData: {
    status: boolean;
    after: number;
    email: {
      status: boolean;
      required: boolean;
    };
    phone: {
      status: boolean;
      required: boolean;
      countryCode: string | null;
    };
    fullName: {
      status: boolean;
      required: boolean;
    };
  };
  limiter: {
    alertText: string;
    limit: number;
    window: number;
  };
  schedule: Schedule;
};

export type SettingKeys = GetKeys<SettingData>;
